/** Set on Rules after `initQuestions`; read on Health Sprint (no insert there). */

const KEY = "healthSprintStageContext";

export function setHealthSprintStageContext({ stageId, questionIds, themeName }) {
  try {
    sessionStorage.setItem(
      KEY,
      JSON.stringify({
        stageId: stageId != null ? Number(stageId) : null,
        questionIds: Array.isArray(questionIds) ? questionIds : [],
        themeName: themeName != null ? String(themeName).trim() : "",
      })
    );
  } catch {
    /* ignore quota / private mode */
  }
}

export function getHealthSprintStageContext() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const p = JSON.parse(raw);
    if (!p || p.stageId == null) return null;
    return {
      stageId: Number(p.stageId),
      questionIds: Array.isArray(p.questionIds) ? p.questionIds : [],
      themeName: p.themeName != null ? String(p.themeName).trim() : "",
    };
  } catch {
    return null;
  }
}

export function clearHealthSprintStageContext() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
